import { render, staticRenderFns } from "./SalesChannels.vue?vue&type=template&id=183ffaa3&scoped=true&"
import script from "./SalesChannels.vue?vue&type=script&lang=ts&"
export * from "./SalesChannels.vue?vue&type=script&lang=ts&"
import style0 from "./SalesChannels.vue?vue&type=style&index=0&id=183ffaa3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183ffaa3",
  null
  
)

export default component.exports